import { Stack, Typography } from "@mui/material";
import { AlertIcon } from "Icons/AlertIcon";

export const DatasetNameBlock = ({ setShowDatasetInfo, datasetName }) => {
  return (
    <Stack
      p="14px 60px 14px 15px"
      width="100%"
      boxSizing="border-box"
      direction="row"
      position="relative"
      gap="19px"
      alignItems="center"
      sx={{ borderRadius: "12px", border: "1px #EAECF0 solid", backgroundColor: "#ffff" }}
    >
      <AlertIcon />
      <Typography variant="body1">
        Genie checked <span style={{ fontWeight: 700 }}>"{datasetName}"</span> and found some issues that
        could be fixed:
      </Typography>
    </Stack>
  );
};
